

import Form from '@/components/Form'
import React, { useEffect } from 'react'
import pricingFormItems from '../forms/pricingFormItems'
import mapPricingToSave from '../mapData/mapPricingToSave'
import savePricing from '@/services/PricingServices/savePricing'
import { closeNotif, startNotif, updateNotif } from '@/components/DynamicForm/util/notifier'
import { Button } from '@/components/UiElements'


type PricingFormProps = {
	model?: any
	onUpdateSuccess?: (updatedPrice: any) => void | Promise<void>
	closeModal?: () => void
}



const PricingForm = ({
	model, onUpdateSuccess, closeModal,
}: PricingFormProps) => {


	const formRef = React.useRef<any>(null)
	const saveButtonLabel = model?.id === "duplicate"
		? 'Save as new Pricing Model'
		: model?.id
			? 'Update Pricing Model'
			: 'Create Pricing Model'
	const formItems = React.useMemo(
		() => pricingFormItems.filter(item => item.name !== 'save'),
		[]
	)

	const handleSaveForm = async () => {

		const toast = startNotif('Validating Pricing Model...')
		const validation = await formRef.current.validate()
		if (!validation) {
			const data:any = formRef.current.getData()
			const mappedData = mapPricingToSave(data)
			const id = data.id
			updateNotif(toast, 'Saving Pricing Model...')
			const saveResult = await savePricing(mappedData, id)
			const responseMessage = typeof saveResult === 'string' ? saveResult : saveResult?.message
			const saveSucceeded = Boolean(saveResult?.id) || responseMessage === 'created' || responseMessage === 'updated'

			if (!saveSucceeded) {
				closeNotif(toast, 'Failed to save Pricing Model.', { type: 'error' })
				return
			}

			data.id = saveResult?.id || id
			data.new = !id
			closeNotif(toast, id ? 'Pricing Model updated successfully.' : 'Pricing Model created successfully.')
			await onUpdateSuccess?.(data)
		}
	}



	useEffect(() => {
		if (model?.id === "duplicate") {
			formRef.current.setData({ ...model, id: null })
		}
	}, [model])


	return (

		<div className={'flex flex-col gap-xxxl'}>
			<div className={'w-[850px] grid grid-cols-12 gap-md'}>
				<Form
					ref={formRef}
					items={formItems}
					defaultValues={{...model}}

				/>
			</div>
			<div className={'flex justify-end gap-md'}>
				{closeModal && (
					<Button size="lg" type="alt" onClick={closeModal}>
						Cancel
					</Button>
				)}
				<Button size="lg" onClick={handleSaveForm}>
					{saveButtonLabel}
				</Button>
			</div>
		</div>
	)
}

export default PricingForm
